module.exports = __webpack_public_path__ + "img/7.fd8d300b.png";